export default __webpack_public_path__ + "static/bottom-swirl-aad27a2688e307d05b7cd49aaa16e848.png";